import I18n from 'I18n';
import getLang from 'I18n/utils/getLang';
export const findValidI18nKey = keys => {
  // @ts-expect-error dependency missing types
  return keys.find(key => I18n.lookup(key));
};
export const getI18nLanguage = () => {
  // @ts-expect-error dependency missing types
  const lang = I18n.loaded && I18n.locale ? getLang() : 'en';
  return lang;
};
const languageIsInMap = (lang, langMap) => {
  return Object.keys(langMap).includes(lang);
};
export const languageToUrl = langMap => {
  const lang = getI18nLanguage();
  if (!languageIsInMap(lang, langMap)) {
    return langMap.en;
  }
  return langMap[lang];
};